export default __webpack_public_path__ + "static/media/Message_info.63cb5361.png";